// extracted by mini-css-extract-plugin
export default {"bottomcon":"dashboard_bottomcon__knm+q","boxcontainer":"dashboard_boxcontainer__R1VTc"};